import { Component } from '@wordpress/element';
import { Button } from '@wordpress/components';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

export default class BlockGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blocks: []
    }
  }

  deleteBlock(id) {
    fetch(this.props.rest_url + 'gutenplatz/v1/delete/' + id)
      .then(result => {
        return result.json()
      })
      .then(data => {
        if (data.success) {
          let blocks = this.state.blocks
          blocks.map((block) => {
            if (block.id == id) {
              block.installed = false
              block.upgrade = false
            }
            return block
          })
          this.setState({blocks: blocks})
        }
      })
  }

  downloadBlock(id) {
    fetch(this.props.rest_url + 'gutenplatz/v1/download/' + id)
      .then(result => {
        return result.json()
      })
      .then(data => {
        if (data.zip_response) {
          let blocks = this.state.blocks
          blocks.map((block) => {
            if (block.id == id) {
              block.installed = true
              block.upgrade = false
            }
            return block
          })
          this.setState({blocks: blocks})
        }
      }).catch((error) => {
        console.log(error)
    })
  }

  componentDidMount () {
    fetch(this.props.url + '/api/blocks/list' , {method:'POST'})
      .then(results => {
        return results.json()
      })
      .then(data => {
        let blocks = data.posts.map((block) => {
          let install = false
          let upgrade = false
          this.props.data.forEach((installed) => {
            if (installed.name === block.name) {
              install = true
              if (installed.version !== block.version) {
                upgrade = true
              }
            }
          })

          return {
            id: block.id,
            title: block.title,
            upgrade: upgrade,
            installed: install,
            name: block.name,
            folder: block.folder,
            description: block.description,
            image: block.image,
            url: block.url
          }
        })
        this.setState({blocks: blocks})
      })
  }

  render ( ) {
      return <div>
      {
        this.state.blocks.map((block, index) => {
          let button
          if (!block.installed) {
            button = <Button isPrimary onClick={() => this.downloadBlock(block.id)}>Download</Button>
          } else if (block.upgrade) {
            button = <Button isDefault onClick={() => this.downloadBlock(block.id)}>Upgrade</Button>
          } else {
            button = <Button onClick={() => this.deleteBlock(block.id)}>Delete</Button>
          }
          return (
            <div key={index} className={'gutenplatz-card'}>
              <div className={'card-top'}>
                <div className={'card-name'}>
                  <img src={block.image[0]} />
                  <h3>{block.title}</h3>
                  {Parser(block.description)}
                </div>
                <div className={'card-buttons'}>
                  <a href={block.url} target={'_blank'} rel="noopener noreferrer">More Info</a>
                  {button}
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  }
}

BlockGrid.propTypes = {
  api_key: PropTypes.string,
  url: PropTypes.string,
  rest_url: PropTypes.string,
  data: PropTypes.array
}